"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

var isNotEmpty = function isNotEmpty(array) {
  return !(0, _isEmpty["default"])(array);
};

var _default = isNotEmpty;
exports["default"] = _default;